
import SEO from '@/services/seo'
import Provider from '@/services/provider'
import gtm from '~/mixins/gtm'
import { head, setAlternate } from '@/utils/head'
import { useApiService } from '~/services/api'

export default {
  mixins: [gtm],

  nuxtI18n: {
    parsePages: false,
    locales: ['pt-br', 'en', 'es'],
  },

  data() {
    return {
      gtmSubsection: 'Home',
      gtmSubsection2: '',
      isLoading: process.env.RUNNING !== 'test',
    }
  },

  fetchOnServer: true,

  async fetch() {
    if (process.server && this.$route.query.update) {
      const locale = this.$i18n.locale.slice(0, 2)
      console.log(`[SERVER] Triggering jobs/sync for locale: ${locale}`)
      await useApiService({
        api: 'apiJobs',
        endpoint: 'jobs',
        url: '/sync',
        method: 'post',
        data: {
          locale: [locale],
        },
      })
      console.log(`[SERVER] jobs/sync completed for locale: ${locale}`)
    }
  },

  head() {
    const locale = this.$i18n.locale
    const { BASE_URL } = process.env

    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    const url = `${BASE_URL}${this.$route.path}`
    const lang = this.$route.name.split('___')[1]
    const title = this.$t('seo.home.title')
    const description = this.$t('seo.shared.description')
    const payload = {
      routeName: this.$route.name,
      param: false,
      data: { areas: false, positions: false },
    }

    return head({
      title,
      lang,
      description,
      url,
      canonical: url,
      htmlAttrs: { ...i18nHead.htmlAttrs },
      link: setAlternate(payload),
      breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
    })
  },
  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },

  mounted() {
    this.isLoading = false
  },
}
